import React from 'react';
import { Label } from '../Label';
export const LabelCrew = ({ cashBack }) => {
    if (!(cashBack === null || cashBack === void 0 ? void 0 : cashBack.value)) {
        return null;
    }
    return (React.createElement(Label, { icon: cashBack && cashBack.boost ? "Boost" : undefined, textColor: "red500", backgroundColor: "red100", letterSpacing: "normal", borderRadius: "2px", padding: "4px 8px 4px 8px", iconSize: "12px", lineHeight: "normal", textTransform: 'none', iconStyle: { marginRight: '6px' } },
        cashBack.multi && "Jusqu'à ",
        cashBack.value,
        cashBack.type === 'p' ? '% ' : '€ ',
        "rembours\u00E9",
        cashBack.value && cashBack.value > 1 && "s"));
};
